import { useQuery } from 'react-query';
import DashboardApiService from '@/modules/dashboard/services/DashboardApiService';

export const useUsersQuantity = (range) => {
  return useQuery(
    ['users-quantity', range],
    () => DashboardApiService.getUsersQuantity({filters: range}),
    { enabled: !!range }
  );
};
